var PriceType = /* @__PURE__ */ ((PriceType2) => {
  PriceType2["TotalListPrice"] = "totalListPrice";
  PriceType2["TotalDiscountedPrice"] = "totalDiscountedPrice";
  PriceType2["UnitListPrice"] = "unitListPrice";
  PriceType2["UnitDiscountedPrice"] = "unitDiscountedPrice";
  PriceType2["LowestListPrice"] = "lowestListPrice";
  PriceType2["HighestListPrice"] = "highestListPrice";
  PriceType2["LowestDiscountPrice"] = "lowestDiscountPrice";
  PriceType2["HighestDiscountPrice"] = "highestDiscountPrice";
  PriceType2["PriceDifference"] = "priceDifference";
  PriceType2["PriceDifferenceDiscounted"] = "priceDifferenceDiscounted";
  PriceType2["SetUpFee"] = "setupFee";
  PriceType2["MinimumQuantity"] = "minimumQuantity";
  return PriceType2;
})(PriceType || {});
var PricePresentationType = /* @__PURE__ */ ((PricePresentationType2) => {
  PricePresentationType2["QtyStartingAtPrice"] = "qtyStartingAtPrice";
  PricePresentationType2["QtyFromPrice"] = "qtyFromPrice";
  PricePresentationType2["AsLowAsPricePerPiece"] = "asLowAsPricePerPiece";
  PricePresentationType2["PricePerUnit"] = "pricePerUnit";
  PricePresentationType2["PlusOrMinus"] = "plusOrMinus";
  PricePresentationType2["RawPrice"] = "rawPrice";
  PricePresentationType2["RangePrice"] = "rangePrice";
  PricePresentationType2["UnitRangePrice"] = "unitRangePrice";
  PricePresentationType2["PriceForQtyUnits"] = "priceForQtyUnits";
  PricePresentationType2["PriceWithQtyAndUnit"] = "priceWithQtyAndUnit";
  PricePresentationType2["RawAndPricePerUnit"] = "rawAndPricePerUnit";
  PricePresentationType2["TotalPrice"] = "totalPrice";
  PricePresentationType2["FromPrice"] = "fromPrice";
  PricePresentationType2["DifferentialPrice"] = "differentialPrice";
  PricePresentationType2["DifferentialPriceForQuantity"] = "differentialPriceForQuantity";
  PricePresentationType2["SetupFee"] = "setupFee";
  return PricePresentationType2;
})(PricePresentationType || {});

export { PricePresentationType, PriceType };
//# sourceMappingURL=src-types-prices.js.map
